import { render, staticRenderFns } from "./ModalRelatorioDepreciacao.vue?vue&type=template&id=009ba238"
import script from "./ModalRelatorioDepreciacao.vue?vue&type=script&lang=js"
export * from "./ModalRelatorioDepreciacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports